export const TABS = {
  IDEALFIT: "idealfit",
  MATCHED: "matched",
  SHORTLISTED: "shortlisted",
  LONGLISTED: "longlisted",
  SKIPPED: "skipped",
  SEARCHRESULTS: "search-results",
  PRECANDIDATES: "pre-candidates",
};
